import React, { useEffect, useState } from "react";
import { Navbar } from "commonComponents/Navbar/Navbar";
import { Sidenav } from "commonComponents/SideNav/Sidenav";
import { useParams } from "react-router-dom";
import { Fleet } from "pages/Fleet/Fleet";
import { Messages } from "pages/Messages";
import { Pace } from "pages/Pace";
import { Ads } from "pages/Ads";
import { AdminPage } from "pages/Admin";
import { FoodAndBeverages } from "pages/FoodAndBeverages/index";
import { MapReactComponent } from "../../pages/Map/MapComponent";
import { ErrorPage } from "pages/ErrorPage/ErrorPage";
import { PinsComponent } from "pages/Pins";
import { useHookstate } from "@hookstate/core";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  SIDENAV_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  CHECKBOX_LOADER,
  SITEID_GLOBAL_STATE,
  UPDATED_CAR_DATA_STATE,
  FB_GLOBAL_STATES,
  APP_CONSTANTS_STATE,
  FLEET_GLOBAL_STATES,
  SITELOCATION_GLOBAL_STATE,
  MAX_HOLES_GLOBAL_STATE,
} from "globalStore/globalStore";
import { Dashboard } from "pages/AdminDashboard";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/css/dashboard.css";
import { useLayoutEffect } from "react";
import { previousDateLoaderReduxAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import moment from "moment";
import { useOrderData } from "customHooks/useOrdersData";
import { toastSuccess } from "_helperFunctions/toast";
import ringer from "assets/sound/Beep.mp3";
import { useFoodOrdersCount } from "customHooks/useFoodOrdersCount";
import CrossIcon from "assets/svgIcons/CloseIcon";
import { FOOD_ORDER } from "localStore/localStore";
import {
  setOldFoodOrderReduxState,
  setOldMessagesBackUpReduxState,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { useSnackbar } from "notistack";
import _ from "lodash";
import { faultBit, featureKey } from "constant";
import i18next from "i18next";
import useInboxMessagesCount from "customHooks/useInboxMessagesCount";
import { People } from "pages/People";

export const PrivateRoutes = () => {
  const audio = new Audio(ringer);
  const { msgInboxCount } = useInboxMessagesCount();
  const [messageAlertAudio] = useState(new Audio(ringer));
  const { id } = useParams();
  const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
  const { LoadingState } = useHookstate(CHECKBOX_LOADER);
  const { getCarsCounter } = useHookstate(APP_CONSTANTS_STATE);
  const { detectChangeMaxHolesAllowed } = useHookstate(MAX_HOLES_GLOBAL_STATE);
  const {
    selectedCarListBackup,
    badgeCount,
    audibleAlertGlobal,
    popUpAlertGlobal
  } = useHookstate(FLEET_GLOBAL_STATES);

  const {
    getCurrentCarsData,
    getCarsData,
    getFoodOrdersTabDataState,
    siteSettingsData,
    newMessagesBackupData,
    oldMessagesBackupData,
    getCarPathActionZone,
    getFaultsData,
    getMessagesFromCarsData,
    newFoodOrderBackupData,
    oldFoodOrderBackupData,
  } = useSelector((state) => state.commonReducers) || [];

  const [reRender] = useState(true);
  const [reRender2, setReRender2] = useState(true);
  const { orderDataState, orderDataCaller } = useOrderData({
    orderData: getFoodOrdersTabDataState,
  });
  const [reloadState, setReloadState] = useState(false);

  const { beepOnNewMessage, beepWhileNotEmpty, popupOnNewMessage } =
    useSelector((state) => state.firstReducer) || [];

  const { orderDataCounter, fbOrdersSettings } = useHookstate(FB_GLOBAL_STATES);

  let foodOrder = FOOD_ORDER;

  if (localStorage.getItem("foodOrder") !== null) {
    foodOrder = JSON.parse(localStorage.getItem("foodOrder"));
  }

  const { pendingFoodOrderCountVal } = useFoodOrdersCount(siteSettingsData);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [fleetAlertsList, setFleetAlertsList] = useState([]);

  //########################################## Message Alert##############################################################//
  const convertDateforMessages = (date) => {
    if (date) {
      function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      }

      const newlyMessageData = formatAMPM(new Date(date));
      return newlyMessageData;
    }
  };

  useEffect(() => {
    let subDomain = id;
    if (subDomain === "foodandbeverages") {
      subDomain = "FoodandBeverages";
    }
    // Set the document title dynamically
    document.title = `${
      subDomain.charAt(0).toUpperCase() + subDomain.slice(1)
    } | Club Car`;
  }, [id]);

  useEffect(() => {
    if (msgInboxCount !== 0 && beepWhileNotEmpty) {
      messageAlertAudio.play();
    }
    if (
      newMessagesBackupData &&
      oldMessagesBackupData 
    ) {
      function getDifference(array1, array2) {
        return array1.filter((object1) => {
          return !array2.some((object2) => {
            return object1.Id === object2.Id;
          });
        });
      }

      const data = getDifference(newMessagesBackupData, oldMessagesBackupData);

      if (data && data.length !== 0 && beepOnNewMessage) {
        messageAlertAudio.play();
        dispatch(setOldMessagesBackUpReduxState(newMessagesBackupData));
      }
      if (data && data.length !== 0 && popupOnNewMessage) {
        data.forEach((car) => {
          toastSuccess({
            message: (
              <>
                <p>
                  From Car {car?.CarNum} @{" "}
                  {convertDateforMessages(car?.Created)}
                  <br /> {car?.Course} {car?.Hole}
                  <br />
                  {car?.Text}
                </p>
              </>
            ),
          });
        });
        dispatch(setOldMessagesBackUpReduxState(newMessagesBackupData));
      }
    }
  }, [getMessagesFromCarsData]);
  //########################################## Message Alert##############################################################//
  useEffect(() => {
    orderDataCaller();
  }, [getFoodOrdersTabDataState]);

  useEffect(() => {
    if (
      orderDataCounter.get() === 1 &&
      fbOrdersSettings.get().fillOrdersHere &&
      fbOrdersSettings.get().popupOnNewOrder &&
      siteSettingsData
    ) {
      let pendingOrdersData =
        orderDataState && orderDataState.length !== 0
          ? orderDataState.filter((order) => !order?.FulfilledDate)
          : [];

      pendingOrdersData.reverse().forEach((order) => {
        toastSuccess({
          message: (
            <>
              <p>Food order pending</p>
              <p>
                From Car {order?.CarNumber} @ {createdTime(order)}
              </p>
            </>
          ),
        });
      });
    }
  }, [
    orderDataCounter.get(),
    fbOrdersSettings.get().fillOrdersHere,
    fbOrdersSettings.get().popupOnNewOrder,
  ]);

  useEffect(() => {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let date = new Date();

      let tempFoodOrdersStartDate = moment().local();
      tempFoodOrdersStartDate.hours(0).minutes(0).seconds(0).milliseconds(0); // midnight course time
      tempFoodOrdersStartDate.utcOffset(-siteSettingsData?.TimeZoneOffset);
      let apiCall;
      let interval = fbOrdersSettings.get().refreshInterval * 1000;
      if (
        fbOrdersSettings.get().fillOrdersHere &&
        window.location.pathname !== "/pins"
      ) {
        apiCall = setInterval(() => {
          dispatch(
            COMMON_SERVICES.getFoodOrdersTabServices(
              tempFoodOrdersStartDate.toISOString(), siteId.get()
            )
          );
        }, interval);

        return () => clearInterval(apiCall);
      } else {
        clearInterval(apiCall);
      }
    }
  }, [fbOrdersSettings.get().fillOrdersHere, siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (
      newFoodOrderBackupData &&
      newFoodOrderBackupData.length !== 0 &&
      oldFoodOrderBackupData &&
      oldFoodOrderBackupData.length !== 0
    ) {
      let difference = newFoodOrderBackupData.filter(
        (item) =>
          !oldFoodOrderBackupData.some((data) => item.OrderId === data.OrderId)
      );
      if (
        difference &&
        difference?.length &&
        fbOrdersSettings.get().beepOnNewOrder
      ) {
        audio.play();
        dispatch(setOldFoodOrderReduxState(newFoodOrderBackupData));
      }

      if (
        difference &&
        difference?.length &&
        fbOrdersSettings.get().popupOnNewOrder
      ) {
        difference?.forEach((v) => {
          toastSuccess({
            message: (
              <>
                <p>Food order pending</p>{" "}
                <p>
                  From Car {v?.CarNumber} @ {createdTime(v)}{" "}
                </p>{" "}
              </>
            ),
          });
        });
        dispatch(setOldFoodOrderReduxState(newFoodOrderBackupData));
      }
    }

    if (
      fbOrdersSettings.get().beepWhileOrderPending &&
      pendingFoodOrderCountVal > 0
    ) {
      audio.play();
    }
  }, [getFoodOrdersTabDataState]);

  function createdTime(order) {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let updated = moment
        .utc(order?.Created)
        .utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to local time zone at course
      return updated.format("hh:mm a");
    }
  }

  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    if (
      siteSettingsData &&
      Object.keys(siteSettingsData).length !== 0 &&
      reloadState &&
      fbOrdersSettings.get().fillOrdersHere &&
      window.location.pathname !== "/pins"
    ) {
      let tempFoodOrdersStartDate = moment().local();
      tempFoodOrdersStartDate.hours(0).minutes(0).seconds(0).milliseconds(0); // midnight course time
      tempFoodOrdersStartDate.utcOffset(-siteSettingsData?.TimeZoneOffset);

      dispatch(
        COMMON_SERVICES.getFoodOrdersTabServices(
          tempFoodOrdersStartDate.toISOString(), siteId.get()
        )
      );
      setReloadState(false);
    }
  }, [fbOrdersSettings.get().fillOrdersHere, siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (!reloadState) {
      setReloadState(true);
    }
  }, [siteId.get()]);

  useLayoutEffect(() => {
    let todayDate = new Date();
    let dateData = `${todayDate.getFullYear()}-${
      todayDate.getMonth() + 1
    }-${todayDate.getDate()}`;
    if (dateData) {
      dispatch(previousDateLoaderReduxAction(dateData));
    }
  }, []);

  useEffect(() => {
    subNavDataState.set(id.toUpperCase());
  }, [id]);

  const { sideDrawerState, sideDrawerActiveTabState, subNavDataState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);

  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const dispatch = useDispatch();

  const oldest = moment(new Date()).format("YYYY-MM-DD");

  useEffect(() => {
  sideDrawerState.set(true);
  dispatch(COMMON_SERVICES.getUserNameAndRoles());
  
  if (siteId.get() !== null && window.location.pathname !== "/pins") {
    dispatch(COMMON_SERVICES.getCarServices(true, siteId.get()));
    dispatch(COMMON_SERVICES.getMessagesFromCarsServices(oldest, siteId.get()));
    dispatch(COMMON_SERVICES.getFaultsServices(siteId.get()));

    const carServicesInterval = setInterval(() => {
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
    }, 30000);

    // To avoid slow Page rendering delay is increased 6 seconds
    const messagesAndFaultsInterval = setInterval(() => {
      dispatch(COMMON_SERVICES.getMessagesFromCarsServices(oldest, siteId.get()));
      dispatch(COMMON_SERVICES.getFaultsServices(siteId.get()));
    }, 60000);

    return () => {
      clearInterval(carServicesInterval);
      clearInterval(messagesAndFaultsInterval);
    };
  }
  
  let sideDrawerActiveTabHistory = localStorage.getItem("sideDrawerActiveTabState");
  let subNavDataHistory = localStorage.getItem("subNavDataState");
  let mapSideNavTabHistory = localStorage.getItem("mapSideNavTabState");
  let sideNavState = JSON.parse(localStorage.getItem("LoadingState"));

  LoadingState.set(sideNavState);
  sideDrawerActiveTabState.set(sideDrawerActiveTabHistory);
  subNavDataState.set(subNavDataHistory);
  mapSideNavTabState.set(mapSideNavTabHistory);
}, []);

  useEffect(() => {
    let reloadState = true;
    if (getCarsData && getCarsData.length > 0 && reloadState) {
      let initialQueryDate = moment(0).utc();
      for (var i = 0; i < getCarsData.length; i++) {
        var car = getCarsData[i];

        var updated = moment.utc(car?.Car?.LastCarUpdateInUtc); // always use .utc() on incoming strings
        // Determine the latest/last date that was returned from our query
        if (updated.isAfter(initialQueryDate)) {
          initialQueryDate = updated;
        }
      }
      localStorage.setItem(
        "lastCarsQueryDate",
        initialQueryDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
      );
    }
    return () => (reloadState = false);
  }, [getCarsData]);

  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getKmlLayerService(siteId.get()));
      dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
    }
  }, [siteId.get()]);

  useEffect(() => {
    if (getCarsCounter.get() === 1) {
      if (getCarsData && getCarsData.length !== 0) {
        updatedCarData.set(JSON.stringify(getCarsData));
        selectedCarListBackup.set(getCarsData);
      } else {
        updatedCarData.set(JSON.stringify([]));
      }
    } else {
      if (getCurrentCarsData && getCurrentCarsData.length !== 0) {
        if (!getCarsData?.length) {
          updatedCarData.set(JSON.stringify([]));
        }
        if (updatedCarData.get() && updatedCarData.get().length !== 0) {
          let carsData = JSON.parse(updatedCarData.get());
          if (carsData && Array.isArray(carsData) && carsData.length > 0) {
            getCurrentCarsData.forEach((element) => {
              const itemIndex = carsData.findIndex(
                (o) => o?.Car?.CarNumber === element?.Car?.CarNumber
              );
              if (itemIndex > -1) {
                carsData[itemIndex] = element;
              } else {
                carsData.push(element);
              }
            });

            selectedCarListBackup.set(carsData);
            updatedCarData.set(JSON.stringify(carsData));
          }
        }
      }
    }
  }, [getCarsData, getCurrentCarsData]);

  let batteryLevel = {
    warning: 25,
    critical: 10,
  };

  let activeCriticalFaults =
    faultBit.FieldMissing |
    faultBit.HwFailSafe |
    faultBit.MainDriverOff |
    faultBit.MainDriverOn |
    faultBit.MainWelded |
    faultBit.MShorted |
    faultBit.SpeedSensorFault;

  let persistentCriticalFaults =
    faultBit.FieldMissing |
    faultBit.HwFailSafe |
    faultBit.MShorted |
    faultBit.InoperableCharger;

  let isCriticalFault = function (activeFaults, persistentFaults) {
    return (
      activeFaults & activeCriticalFaults ||
      persistentFaults & persistentCriticalFaults
    );
  };

  let doesCarHaveCriticalFault = function (gpsiCarId) {
    let fault = _.find(getFaultsData, { GpsiCarId: gpsiCarId });
    return fault !== undefined
      ? isCriticalFault(fault.ActiveFaults, fault.PersistentFaults)
      : false;
  };

  function getActionZoneAlert(azID) {
    if (azID > 0) {
      if (getCarPathActionZone) {
        let az = _.find(getCarPathActionZone, function (dcAZ) {
          return dcAZ.Id === azID;
        });
        if (az) {
          return az.IsAlertOnEnter; // TBD add other alerts type when available
        }
      }
    }
    return false;
  }

  function getActionZoneLabel(azID) {
    if (getCarPathActionZone) {
      let az = _.find(getCarPathActionZone, function (dcAZ) {
        return dcAZ.Id === azID;
      });
      if (az) {
        return az.Label ? az.Label : "";
      }
    }
    return "";
  }

  const triggerSnackbar = (label) => {
    enqueueSnackbar(label, {
      preventDuplicate: true,
      autoHideDuration: 10000,
      letiant: "warning",
      action: (key) => (
        <CrossIcon
          width={20}
          height={20}
          color="#ffffff"
          onClick={() => closeSnackbar(key)}
        />
      ),
      anchorOrigin: { vertical: "bottom", horizontal: "right" },
      sx: {
        "& .SnackbarContent-root": {
          color: "white",
          backgroundColor: "rgb(189, 54, 47)",
          width: 200,
          height: 100,
        },
      },
    });
  };

  const connectionType = {
    wifi: 0,
    realtime: 1,
    none: 2,
  };

  const carType = {
    normal: 1,
    marshal: 2,
    handicap: 3,
    bevcart: 4,
    outOfService: 5,
    member: 6,
  };

  function hasActiveAlert(car) {
    if (car.SOSAlertEnabled) return true;
    if (car.CarNumber < 0) return false; // don't count negative car #s for non admin
    if (car.Connection === connectionType.none) return false; // don't count cars not communicating
    if (car.CarType === carType.outOfService) return false; // don't count out of service
    if (car.ActionZoneId) return getActionZoneAlert(car.ActionZoneId); // return true if this zone is set for alerts
    if (car.MaxHolesExceeded) return true;
    if (car.GuardianCapable === false)
      // if individual car has been explictly marked to NOT use Guardian
      return false; // don't check this car
    if (doesCarHaveCriticalFault(car.GpsiCarId)) return true;
    if (car.BatteryLevel <= batteryLevel.critical && !car.IsCharging)
      // don't count low battery if on charge
      return true;
    if (car.hasChargeAlert) return true;
    return false;
  }

  function addCarToAlertsList(car) {
    var datum = {
      car: car,
      faultAlert: doesCarHaveCriticalFault(car.GpsiCarId),
      batteryAlert:
        car.BatteryLevel <= batteryLevel.critical && !car.IsCharging,
      azAlert: getActionZoneAlert(car.ActionZoneId),
      azText: getActionZoneLabel(car.ActionZoneId),
      maxHolesAlert: car.MaxHolesExceeded,
      sosAlert: car.SOSAlertEnabled,
    };

    showFleetAlertPopUp(datum);
  }

  function showFleetAlertPopUp(alertItem) {
    // Format text for Toast

    if (!siteLocationGlobalData.get()) {
      var criticalFaultAlert = alertItem.faultAlert ? "Critical fault" : "";
      var batteryAlert = alertItem.batteryAlert ? "Critical battery" : "";
      var azAlertText =
        getActionZoneLabel(alertItem.car.ActionZoneId) != ""
          ? getActionZoneLabel(alertItem.car.ActionZoneId) + " " + "entered"
          : "";
      var actionZoneAlert = alertItem.azAlert
        ? "Action Zone" + ": " + azAlertText
        : "";
      var maxHolesAlertText = alertItem.maxHolesAlert ? "Max Holes Played" : "";
      var textalert =
        "Car" +
        alertItem.car.CarNumber +
        criticalFaultAlert +
        batteryAlert +
        actionZoneAlert +
        maxHolesAlertText;
      triggerSnackbar(`Fleet Alert: ${textalert} `);
      if (audibleAlertGlobal.get()) audio.play();
    }
  }

  useEffect(() => {
    let parsedCarsData =
      !Array.isArray(updatedCarData.get()) &&
      typeof updatedCarData.get() === "string" &&
      JSON.parse(updatedCarData.get());
    if (
      popUpAlertGlobal.get() &&
      updatedCarData.get() &&
      Array.isArray(parsedCarsData) &&
      parsedCarsData.length !== 0 &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0 &&
      siteSettingsData?.Features.indexOf(featureKey.tracking) >= 0 &&
      getCarPathActionZone &&
      getCarPathActionZone.length > 0
    ) {
      if (siteSettingsData?.GuardianCapable) {
        let tempArray = parsedCarsData.filter((cData) => {
          return hasActiveAlert(cData.Car);
        });

        badgeCount.set(tempArray.length);
        setFleetAlertsList(tempArray);
        if (tempArray.length > 0) {
          if (tempArray.length > fleetAlertsList.length) {
            tempArray.forEach((item) => {
              addCarToAlertsList(item.Car);
            });
          }
        }
      }
    }
  }, [
    updatedCarData.get(),
    siteSettingsData,
    getCarPathActionZone,
    popUpAlertGlobal.get(),
    audibleAlertGlobal.get(),
  ]);

  const changePage = (pageName) => {
    switch (pageName) {
      case "map":
        return <MapReactComponent />;
      case "fleet":
        return <Fleet />;
      case "messages":
        return <Messages />;
      case "pace":
        return <Pace />;
      case "ads":
        return <Ads />;
      case "foodandbeverages":
        return <FoodAndBeverages />;
      case "pins":
        return <PinsComponent />;
      case "dashboard":
        return <Dashboard />;
      case "admin":
        return <AdminPage />;
      case "people":
        return <People />;
      default:
        return <ErrorPage />;
    }
  };

  useEffect(() => {
    setReRender2(false);
  }, [reRender]);

  const clickedOnMainContainer = () => {
    if (
      subNavDataState.get() === "MAP" ||
      subNavDataState.get() === "Map" ||
      subNavDataState.get() === "map"
    ) {
      return;
    } else {
      hideSubNav.set(false);
    }
  };

  useEffect(() => {
    if (
      sideDrawerActiveTabState.get() !== 2 ||
      mapSideNavTabState.get() !== "Settings"
    ) {
      detectChangeMaxHolesAllowed.set(false);
    }
  }, [mapSideNavTabState.get(), sideDrawerActiveTabState.get()]);

  return (
    <React.Fragment>
      {/* ================================================ Navbar Start =========================================== */}
      <Navbar />
      {/* ================================================ Navbar End =========================================== */}

      <section className={`container-flex ${i18next.language}`}>
        {/* ================================================ Sidebar Start =========================================== */}
        <Sidenav />
        {/* ================================================ Sidebar End =========================================== */}

        {/* ================================================ SidenavPages Start =========================================== */}

        <div
          style={{
            width: "100%",
            overflow: "auto",
          }}
          onClick={clickedOnMainContainer}
        >
          {siteId.get() === null && (
            <div style={{ fontSize: "36px", fontWeight: "bold", textAlign: "center", padding: "20px" }}>
              Choose Site...
            </div>
          )}

          {!reRender2 ? changePage(id) : null}
        </div>
        {/* ================================================ SidenavPages End =========================================== */}
      </section>
    </React.Fragment>
  );
};
